<template>
<div>
    <b-container>
        <b-row class="headerpic" align-v="center">
            <b-col>
                <span class="txtabout"><b><span class="txtbolder">graphic</span></b> design & advertising agency</span>
            </b-col>
            <b-col class="col-6">
                <b-img class="gdgrid" :src="wurl+'/imgsrv/gdgrid.png'" fluid alt="Responsive image"></b-img>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <br>
                <b-breadcrumb :items="items"></b-breadcrumb>
            </b-col>
        </b-row>
        <b-row class="content">
            <b-col>
                <b-card class="shadow">
                    <b-row>
                        <b-col lg="6" md="6" sm="12" xs="12">

                            <div v-if="langfrench" v-html="content_fr"></div>
                            <div v-else v-html="content_en"></div>

                        </b-col>
                        <b-col lg="6" md="6" sm="12" xs="12">
                            <div>
                                <b-form @submit="onSubmit" @reset="onReset" v-if="show">
                                    <b-form-group id="input-group-3" :label="this.motiflabel" label-for="input-3">
                                        <b-form-select id="input-3" v-model="form.motif" :options="motif" required></b-form-select>
                                    </b-form-group>
                                    <b-form-group id="input-group-1" :label="this.adresse_email" label-for="input-1" :description="this.email_texte_description">
                                        <b-form-input id="input-1" v-model="form.email" type="email" required :placeholder="this.votre_adresse_email"></b-form-input>
                                    </b-form-group>

                                    <b-form-group id="input-group-3" :label="this.prenom" label-for="input-3">
                                        <b-form-input id="input-3" v-model="form.surname" required :placeholder="this.votre_prenom"></b-form-input>
                                    </b-form-group>

                                    <b-form-group id="input-group-2" :label="this.nom" label-for="input-2">
                                        <b-form-input id="input-2" v-model="form.name" required :placeholder="this.votre_nom"></b-form-input>
                                    </b-form-group>

                                    <b-form-group id="input-group-4" :label="this.tel" label-for="input-4">
                                        <b-form-input id="input-4" v-model="form.tel" required :placeholder="this.votre_tel"></b-form-input>
                                    </b-form-group>

                                    <b-form-group id="input-group-5" :label="this.message" label-for="input-5">
                                        <b-form-textarea id="textarea" v-model="form.text" required :placeholder="this.votre_message" rows="3" max-rows="6"></b-form-textarea>
                                    </b-form-group>
                                    <b-button type="submit" pill variant="outline-secondary">{{ this.sendButtonTitle }}</b-button>
                               
                                </b-form>
                            </div>
                        </b-col>
                    </b-row>
                </b-card>
            </b-col>
        </b-row>
    </b-container>
</div>
</template>

<script>
//bus for handling component interconnection
import {
    EventBus
} from "@/event-bus.js";
import axios from 'axios'
import {
    globalSiteSetting
} from "../main.ts";
export default {
    data() {
        return {
            wurl: globalSiteSetting.siteurl,
            items: [],
            items_fr: [{
                    text: 'Accueil',
                    to: '/'
                },
                {
                    text: 'Contact',
                    active: true
                }
            ],
            items_en: [{
                    text: 'Home',
                    to: '/'
                },
                {
                    text: 'Contact',
                    active: true
                }
            ],
            langfrench: true,
            content: '',
            content_fr: '',
            content_en: '',
            title_fr: '',
            title_en: '',

            sendButtonTitle: 'Envoyer',
            cancelButtonTitle: 'Annuler',

            headerpic: 'ajaxloader.gif',

            adresse_email: 'Adresse email',
            email_texte_description: 'Nous ne partagerons jamais votre e-mail avec qui que ce soit',
            votre_adresse_email: 'Votre adresse email',

            nom: 'Nom',
            votre_nom: 'Votre nom',

            prenom: 'Prénom',
            votre_prenom: 'Votre prénom',

            tel: 'Tél/Mobile',
            votre_tel: 'Votre numéro téléphone ou mobile',

            message: 'Messages:',
            votre_message: 'Votre message...',

            form: {
                email: '',
                name: '',
                surname: '',
                tel: '',
                text: ''

            },
            motif:[],
            motiffr: [{ text: 'Demander un devis', value: 'devis' },
            { text: 'Demander un rendez-vous', value: 'rendez-vous' },
             { text: 'Demander un renseignement', value: 'renseignement' },
             { text: 'Postuler pour un travail', value: 'job' }
            ],
            motifen: [{ text: 'Ask for a quote', value: 'devis' },
            { text: 'Request an appointment', value: 'rendez-vous' },
             { text: 'Ask for information', value: 'renseignement' },
             { text: 'Apply for a job', value: 'job' }
            ],
            show: true
        }
    },
    methods: {
        retrievedata() {
            var app = this
            var weburl = this.wurl
            axios.get(weburl + '/api.data.php?req=content&p=contact&auth=razafy', {
                    crossDomain: true
                })
                .then(response => {
                    //console.log('title is:'+ response.data.title)
                    // console.log('content is:'+ response.data.content)
                    //console.log('headerpic is:' + response.data.headerpic)

                    this.content_fr = response.data.content_fr
                    this.content_en = response.data.content_en
                    this.headerpic = response.data.headerpic
                    //attribute default value for french
                    if (this.langfrench == true) {
                        this.content = this.content_fr
                    }

                })
        },
        onSubmit(evt) {
            evt.preventDefault()
            //alert(JSON.stringify(this.form))
            var weburl = this.wurl;
            this.contenttosendtomail ='Motif:' + this.form.motif + '<br>'+ 'Nom:' + this.form.name + ' ' + '<br>' + 'Prénom:' + this.form.surname + '<br>' + 'Tél:' + this.form.tel + '<br>' + 'Email:' + this.form.email + '<br>' + 'Message:' + this.form.text
            var url = weburl + '/api.data.php?req=postmail&type=contact&content=' + this.contenttosendtomail + '&auth=razafy'
            var urlencoded = encodeURI(url)

            axios.get(urlencoded)
                .then(response => {
                    //console.log('status is:' + response.data.message)
                    //console.log('content is:'+ response.data.content)
                    alert('Message envoyé avec succès')

                })

        },
        onReset(evt) {
            evt.preventDefault()
            // Reset our form values
            this.form.email = ''
            this.form.name = ''
            this.form.surname = ''
            this.form.tel = ''
            this.form.text = ''

            // Trick to reset/clear native browser form validation state
            this.show = false
            this.$nextTick(() => {
                this.show = true
            })
        },
        scrollToTop() {
            // scroll on top every load page        
            window.scrollTo(0, 0);
        },
        togglefrenchlangage() {
            this.langfrench = true
            this.setTextOnFormToFrench()
            this.items = this.items_fr
            this.content = this.content_fr
            this.motif = this.motiffr
            // console.log('lang is now french in about')
            //change page title
            window.document.title = 'Graphikodesign | Contact'
        },
        toggleenglishlangage() {
            this.langfrench = false
            this.setTextOnFormToEnglish()
            this.items = this.items_en
            this.content = this.content_en
            this.motif = this.motifen
            // console.log('lang is now english in about')
            //change page title
            window.document.title = 'Graphikodesign | Contact'
        },
        setTextOnFormToFrench() {

            this.motiflabel = 'Motif',
            this.adresse_email = 'Adresse email',
                this.email_texte_description = 'Nous ne partagerons jamais votre e-mail avec qui que ce soit',
                this.votre_adresse_email = 'Votre adresse email',

                this.nom = 'Nom',
                this.votre_nom = 'Votre nom',

                this.prenom = 'Prénom',
                this.votre_prenom = 'Votre prénom',

                this.tel = 'Tél/Mobile',
                this.votre_tel = 'Votre numéro téléphone ou mobile',

                this.message = 'Messages:',
                this.votre_message = 'Votre message...',

                this.sendButtonTitle = 'Envoyer',
                this.cancelButtonTitle = 'Annuler'

        },
        setTextOnFormToEnglish() {
            this.motiflabel = 'Subject',
            this.adresse_email = 'Email address',
                this.email_texte_description = 'We will never share your email with anyone',
                this.votre_adresse_email = 'E-mail address',

                this.nom = 'Last Name',
                this.votre_nom = 'Last name..',

                this.prenom = 'First name',
                this.votre_prenom = 'First name...',

                this.tel = 'Tel/Mobile',
                this.votre_tel = 'Phone number',

                this.message = 'Messages:',
                this.votre_message = 'Message...',

                this.sendButtonTitle = 'Send',
                this.cancelButtonTitle = 'Cancel'
        },
        checkifcookieexistornot() {

            if (this.$cookie.get('gd_langinfrench') === 'true') {
                this.langfrench = true
                this.setTextOnFormToFrench()

                this.items = this.items_fr
                this.content = this.content_fr
                EventBus.$emit('togglelangtofrench')
            } else {
                this.langfrench = false
                this.setTextOnFormToEnglish()

                this.items = this.items_en
                this.content = this.content_en
                //console.log('ato o....and content is:'+this.content_en)
                EventBus.$emit('togglelangtoenglish')
            }
        }
    },
    mounted() {
        this.retrievedata()
        this.scrollToTop()
        this.checkifcookieexistornot()
        //init message
        this.form.motif = 'devis'
        if (this.langfrench == true) {
            this.items = this.items_fr
            this.motif = this.motiffr
            //change page title
            window.document.title = 'Graphikodesign | Contact'
        } else {
            this.items = this.items_en
            this.motif = this.motifen
            //change page title
            window.document.title = 'Graphikodesign | Contact'
        }

        //listen to langage change
        EventBus.$on('togglelangtofrench', () => {
            this.togglefrenchlangage()
        })
        EventBus.$on('togglelangtoenglish', () => {
            this.toggleenglishlangage()
        })
    }
}
</script>
